import { motion } from "framer-motion";

const directions = {
  up: { y: 28, x: 0 },
  down: { y: -28, x: 0 },
  left: { x: 34, y: 0 },
  right: { x: -34, y: 0 },
  none: { x: 0, y: 0 },
};

/**
 * Scroll-triggered entrance. Fires once, respects reduced motion through the
 * global CSS override, and keeps every section on the same timing curve.
 */
const Reveal = ({
  children,
  delay = 0,
  from = "up",
  duration = 0.7,
  className = "",
  as = "div",
}) => {
  const MotionTag = motion[as] || motion.div;
  const offset = directions[from] || directions.up;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, ...offset }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
